export const LOGO_TYPE = {
  TEXT: 'Text',
  IMAGE: 'Image',
  NONE: 'None',
} as const;

export type LOGO_TYPE_KEY = keyof typeof LOGO_TYPE;

export type LOGO_TYPE_VALUE = typeof LOGO_TYPE[LOGO_TYPE_KEY];
